import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { TenantService } from '../tenant/tenant.service';

/**
 * Pedidos em que **não** devemos injetar `X-Company-Id` (login, refresh, formulários públicos).
 * Importante: **não** usar o prefixo largo `/api/auth/` — rotas como `/api/auth/me` no MVP precisam
 * do tenant no header (senão a API pode responder 400).
 */
function isCompanyScopeSkipped(url: string): boolean {
  const n = url.toLowerCase();
  if (n.includes('/forms/public') || n.includes('/api/forms/public')) return true;

  const authWithoutCompany = [
    '/api/auth/signin',
    '/api/auth/login',
    '/api/auth/signup',
    '/api/auth/forgot-password',
    '/api/auth/register',
    '/api/auth/refresh',
    '/auth/signin',
    '/auth/login',
    '/auth/signup',
    '/auth/forgot-password',
    '/auth/refresh',
  ];
  return authWithoutCompany.some((path) => n.includes(path));
}

/** Resolução de tenant por chave pública não deve enviar X-Company-Id antigo. */
function isCompanyContextByKeyRequest(url: string): boolean {
  const u = url.toLowerCase();
  return (
    u.includes('/api/companies/context/') ||
    u.includes('/api/company-context/') ||
    u.includes('/api/companies/by-key/') ||
    /\/api\/companies\/[^/]+\/context/i.test(url)
  );
}

export const companyInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has('X-Company-Id') || isCompanyScopeSkipped(req.url) || isCompanyContextByKeyRequest(req.url)) {
    return next(req);
  }

  const tenant = inject(TenantService);
  const auth = inject(AuthService);
  const companyId = tenant.getActiveCompanyId() ?? auth.currentUser()?.companyId ?? null;
  if (!companyId) return next(req);
  const cloned = req.clone({
    setHeaders: { 'X-Company-Id': companyId },
  });
  return next(cloned);
};
